import { render, staticRenderFns } from "./LiveSalesData.vue?vue&type=template&id=97442398&scoped=true"
import script from "./LiveSalesData.vue?vue&type=script&lang=js"
export * from "./LiveSalesData.vue?vue&type=script&lang=js"
import style0 from "./LiveSalesData.vue?vue&type=style&index=0&id=97442398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97442398",
  null
  
)

export default component.exports